// extracted by mini-css-extract-plugin
module.exports = {"user-info":"user-info__aeJUI","user-info-inner":"user-info-inner__3F2pi","active":"active__VaT8t","profile":"profile__1B3Kk","name":"name__1xmlL"};